import signalEventsService from "app/pages/sales-intelligence/modules/company-analysis/services/signals/signalEventsService";
import type { AdNetworkSignalEventDto } from "app/pages/sales-intelligence/modules/company-analysis/types/signals";

import NameStringWithTooltip from "./NameStringWithTooltip";

type AdNetworkSignalEventInfoProps = {
    signal: AdNetworkSignalEventDto;
    companyName: string;
};

const AdNetworkSignalEventInfo = ({ signal, companyName }: AdNetworkSignalEventInfoProps) => {
    const { adNetworkIds, adNetworkNames } = signal;

    if (adNetworkIds.length === 1) {
        return null;
    }

    return (
        <NameStringWithTooltip
            names={adNetworkNames}
            text={signalEventsService.getAdNetworkSignalEventActionText(signal, companyName)}
        />
    );
};

export default AdNetworkSignalEventInfo;
